<template>
  <div class="cardlist">
    <div class="cardlist-title">
      <div class="cardlist-title-text">选择支付方式</div>
      <div
        class="cardlist-title-close"
        @click="$eb.$emit('showCardList', false)"
      ></div>
    </div>
    <div class="cardlist-body">
      <div v-if="hint" class="cardlist-body-hint">
        <span>{{ hint }}</span>
      </div>
      <div class="cardlist-body-list">
        <div
          v-for="(item, index) in cardinfo"
          :key="index"
          class="cardlist-body-list-item"
          @click="changeCard(index)"
        >
          <Card :cardinfo="item"></Card>
          <!-- 添加银行卡项：显示箭头 -->
          <div
            v-if="item.bankcardId === '1'"
            class="cardlist-body-list-item-check-icon"
          ></div>
          <!-- 其他银行卡项 -->
          <template v-else>
            <template v-if="!cardList[index].isSign">
              <div class="cardlist-body-list-item-check-text">去完善</div>
              <div class="cardlist-body-list-item-check-icon"></div>
            </template>
            <div
              v-else-if="cardList[index].isDefault && cardList[index].isEnable"
              class="cardlist-body-list-item-icon selected"
            ></div>
            <div
              v-else-if="cardList[index].isEnable"
              class="cardlist-body-list-item-icon unselected"
            ></div>
          </template>
          <div
            v-if="index !== cardinfo.length - 1"
            class="cardlist-body-list-item-split"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Card from './card'
export default {
  name: 'CardList',
  components: {
    Card,
  },
  props: {
    cardList: {
      type: Array,
      default: () => [],
    },
    hint: {
      type: String,
      default: '',
    },
    pageActionType: {
      type: Number,
      default: 0,
    },
    brightness: {
      type: Number,
      default: 0.8,
    },
  },
  computed: {
    cardinfo() {
      return this.cardList.map((p) => {
        let labelInfo = ''
        if (p.bankcardId === '1') {
          labelInfo = '添加银行卡，扫码后直接付款'
        } else if ([4, 6].includes(this.pageActionType)) {
          labelInfo = p.bankcardDesc
        } else {
          labelInfo = p?.promotion?.labels
        }
        // bankcardId为1时是添加银行卡，-5时默认括号内文字为尝鲜特权
        let text =
          p.bankcardId === '1'
            ? p.bankcardName
            : `${p.bankcardName}${
                p.bankcardNo
                  ? `(${p.bankcardNo})`
                  : p.bankcardId === '-5'
                  ? '(尝鲜特权)'
                  : ''
              }`
        return {
          icon:
            p.bankcardId === '1'
              ? '//p1.meituan.net/scarlett/9a8be4b164718b64260823ac6ae24e00526.png'
              : p.isEnable
              ? p.bankLogo
              : p.bankGreyLogo,
          text,
          labelInfo,
          bankcardId: p.bankcardId,
        }
      })
    },
  },
  mounted() {
    this.$lx.switchPayTypeModuleMV()
    this.cardList.forEach((p) => {
      if (p.bankcardId === '1') {
        this.$lx.addBankMV()
      } else {
        this.$lx.switchPayTypeMV({
          bank_name: p.bankcardName,
          bank_type_id: p.bankcardId,
          promotion: p?.promotion?.promotionDetails || [],
        })
      }
    })
  },
  methods: {
    changeCard(index) {
      const item = this.cardList[index]
      let url
      if (item.bankcardId !== '1') {
        this.$lx.switchPayTypeMC({
          bank_name: item.bankcardName,
          bank_type_id: item.bankcardId,
          promotion: item?.promotion?.promotionDetails || [],
        })
      }
      // 添加卡片，跳转绑卡页面
      if (item.bankcardId === '1') {
        this.$lx.addBankMC()
        this.$eb.$on('closeCardList')
        url = `${process.env.VUE_APP_BIND_CARD_URL ||
          'https://npay.meituan.com/portal/bindcard/bindcard.html?merchant_no=11000004918439&callback_type=close_webview&ext_dim_stat_entry=payment_code&_mtcq=0'}&no_foreign_card=1&ext_dim_stat_custom=%7B%22entry%22:%22quickpass_qrcode%22%7D#/`
        this.$bridge.openPage(url)
        return
      }
      // 银行卡信息不完善，跳转完善银行卡信息页面
      if (!item.isSign) {
        this.$eb.$on('closeCardList')
        url = `${process.env.VUE_APP_BIND_CARD_URL ||
          'https://npay.meituan.com/portal/bindcard/bindcard.html?merchant_no=11000004918439&callback_type=close_webview&ext_dim_stat_entry=payment_code&_mtcq=0'}&no_foreign_card=1&bank_card_id=${
          item.bankcardId
        }`
        this.$bridge.openPage(url)
        return
      }
      // 银行卡被禁用，点击不做处理
      if (!item.isEnable) {
        return
      }
      this.$eb.$emit('changeCard', index)
    },
  },
}
</script>
<style lang="less">
@import '../assets/variable.less';
.cardlist {
  .flex-column-center();
  z-index: 13;
  position: fixed;
  bottom: 0;
  left: 0;
  max-height: 88vh;
  width: 100%;
  border-radius: 20px 20px 0 0;
  background: #FAFAFA;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  padding-bottom: 39px;
  box-sizing: border-box;

  &-title {
    background: transparent;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: center;
    padding: 0 15px;
    height: 54px;
    width: 100%;
    flex-shrink: 0;
    position: relative;

    &-text {
      color: #111111;
      font-family: PingFang SC, sans-serif;
      font-weight: 500;
      font-size: 18px;
      line-height: 25px;
      text-align: center;
    }

    &-close {
      position: absolute;
      right: 16px;
      width: 18px;
      height: 18px;
      background-image: url('~@/assets/img/halfpage_close@3x.png');
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
      flex-shrink: 0;
    }
  }

  &-body {
    margin-left: 16px;
    margin-right: 16px;
    margin-bottom: 18px;
    flex: 1;
    background: #FFFFFF;
    border-radius: 10px;
    .flex-column-center();
    width: calc(100% - 32px);
    overscroll-behavior: contain;
    overflow: auto;
    &-hint {
      .flex-center(center);
      width: 100%;
      min-height: 40px;
      background: rgba(255, 74, 74, 0.1);
      padding: 13px 15px;
      > span {
        .font-area(14px);
        display: inline-block;
        font-family: PingFangSC-Regular;
        color: #ff4a4a;
        letter-spacing: 0;
        text-align: left;
      }
    }
    &-list {
      .flex-column-center();
      width: 100%;
      &-item {
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        justify-content: space-between;
        width: 100%;
        padding: 0 14px;
        position: relative;
        &-icon {
          width: 18px;
          height: 18px;
          background-size: contain;
          background-repeat: no-repeat;
          background-position: center;
          flex-shrink: 0;
          margin-top: 19px;

          &.selected {
            background-image: url('~@/assets/img/selected.png');
            width: 20px;
            height: 20px;
          }

          &.unselected {
            background-image: url('~@/assets/img/unselect.png');
            width: 20px;
            height: 20px;
          }
        }
        &-check-text {
          font-family: PingFang SC, sans-serif;
          font-weight: 400;
          font-size: 14px;
          color: #555555;
          line-height: 20px;
          text-align: center;
          flex-shrink: 0;
          margin-top: 19px;
        }

        &-check-icon {
          width: 20px;
          height: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          margin-top: 19px;

          background-image: url('~@/assets/img/guide_arrow@3x.png');
          background-size: 11px 11px;
          background-repeat: no-repeat;
          background-position: center;
        }
        &-split {
          position: absolute;
          height: 1px;
          left: 41px;
          right: 0;
          transform: scaleY(0.5);
          background: rgba(0, 0, 0, 0.06);
          bottom: 0;
        }
      }
    }
  }
}
</style>
